import React from "react";

export const SkeletonCard = () => {
  return (
    <div className="relative overflow-hidden bg-slate-800/40 border border-slate-700/50 rounded-lg p-4">
      <div className="absolute inset-0 -translate-x-full animate-[shimmer_2s_infinite] bg-gradient-to-r from-transparent via-white/10 to-transparent" />

      {/* Image skeleton */}
      <div className="w-full aspect-video bg-slate-700/50 rounded-md mb-3" />

      {/* Title skeleton */}
      <div className="h-5 bg-slate-700/50 rounded w-3/4 mb-2" />

      {/* Subtitle skeleton */}
      <div className="h-4 bg-slate-700/50 rounded w-1/2 mb-3" />

      {/* Bottom info skeleton */}
      <div className="flex justify-between items-center">
        <div className="h-4 bg-slate-700/50 rounded w-16" />
        <div className="h-4 bg-slate-700/50 rounded w-12" />
      </div>
    </div>
  );
};